// deno-coverage-ignore-start - unreachable by definition
/** Used for unreachable logic */
export function Unreachable() {
    throw new Error('Unreachable');
}
// deno-coverage-ignore-stop
